import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import PaymentMethodPicker from './MethodPicker';
import PaymentMethodForm from './form';
import { trackNow } from 'shared/models/analytic';
import { PrimaryButton } from 'scy/buttons';
import { width100, textCenter } from 'scy/utils.mod.scss';
import AddNewButton from 'components/checkoutPage/form/AddNewButton';
import Subsection from 'components/checkoutPage/form/Subsection';
import padding from 'scy/padding.mod.scss';

class PaymentMethods extends React.Component {
  constructor(props) {
    super(props);
    const preselected = this._preselected(props);
    this.state = {
      showNew: false,
      selected: preselected || {}
    };
  }

  _preselected(props) {
    if (!_.isEmpty(props.selected)) return props.selected;
    if (props.paymentRequestPayment) return props.paymentRequestPayment;
    if (props.paymentMethods.length) return props.paymentMethods[0];
  }

  openNewPaymentMethod() {
    this.setState({ showNew: true });
    trackNow('Add New Payment Clicked');
  }

  closeNewPaymentMethod() {
    this.setState({ showNew: false });
    trackNow('Add New Payment Canceled');
  }

  select(method) {
    this.setState({ selected: method });
  }

  confirmSelection() {
    this.props.onSelectionSubmit(this.state.selected);
  }

  render() {
    if (this.props.loading || this.props.paymentRequestLoading) {
      return (
        <div className={`${padding.md} ${textCenter}`}>
          <LoadingSpinner black inline />
        </div>
      );
    }

    const paymentRequestPayment = this.props.paymentRequestPayment;
    const paymentMethods = (paymentRequestPayment
      ? [paymentRequestPayment]
      : []
    ).concat(this.props.paymentMethods || []);

    return !paymentMethods.length ? (
      <PaymentMethodForm
        onSuccess={this.props.onNewPaymentSuccess}
        deliveryAddress={this.props.deliveryAddress}
      />
    ) : (
      <>
        <PaymentMethodPicker
          paymentMethods={paymentMethods}
          onChange={method => this.select(method)}
          selectedItem={this.state.showNew ? null : this.state.selected}
        />

        {this.state.showNew ? (
          <PaymentMethodForm
            fieldsContainer={props => (
              <Subsection heading="New Payment Method" {...props} />
            )}
            onCancel={() => this.closeNewPaymentMethod()}
            onSuccess={this.props.onNewPaymentSuccess}
            deliveryAddress={this.props.deliveryAddress}
          />
        ) : (
          <>
            <AddNewButton
              onClick={() => this.openNewPaymentMethod()}
              text="Add New Payment Method"
            />

            <div className="row">
              <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
                <PrimaryButton
                  type="button"
                  className={width100}
                  onClick={() => this.confirmSelection()}
                >
                  Continue
                </PrimaryButton>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const ConnectedPaymentMethods = connect(
  state => ({
    selected: state.checkout.paymentMethod,
    paymentRequestPayment: state.checkout.paymentRequestPayment,
    paymentRequestLoading: state.checkout.paymentRequestLoading,
    paymentMethods: state.payment.cards || [],
    loading: state.payment.loading,
    user: state.login.user || {}
  }),
  {}
)(PaymentMethods);

export default ConnectedPaymentMethods;
